import React, { Fragment } from 'react';
import lodash from 'lodash';
import styles from './StudyType.scss';
import {
    StudyFormField,
    PrimaryStepAction,
    StudyStepTitle,
    StudyStepInfoContainer,
} from 'pages/study/containers/components/StudyFormField';

class StudyType extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            studyName: this.getStudyFieldValue('studyName'),
            studyType: this.getStudyFieldValue('studyType'),
            studyStage: this.getStudyFieldValue('studyStage'),
            studyTypesOptions: lodash.get(props, 'stepData.studyTypes'),
            studyStageOptions: lodash.get(props, 'stepData.studyStages'),
        };

        this.onNameChange = this.onNameChange.bind(this);
        this.onTypeChange = this.onTypeChange.bind(this);
        this.onStageChange = this.onStageChange.bind(this);
        this.completeStep = this.completeStep.bind(this);
        this.missingFields = this.missingFields.bind(this);
        this.isDisabled = this.isDisabled.bind(this);
    }

    componentDidUpdate(prevProps) {

        // Populate select options.
        const prevStudyStages = lodash.get(prevProps, 'stepData.studyStages');
        const currentStudyStages = lodash.get(this.props, 'stepData.studyStages');

        const prevStudyTypes = lodash.get(prevProps, 'stepData.studyTypes');
        const currentStudyTypes = lodash.get(this.props, 'stepData.studyTypes');

        if (!lodash.isEqual(currentStudyTypes, prevStudyTypes)) {
            this.setState({ studyTypesOptions: currentStudyTypes });
        }

        if (!lodash.isEqual(currentStudyStages, prevStudyStages)) {
            this.setState({ studyStageOptions: currentStudyStages });
        }

        // Populate default selected
        const prevStudyType = lodash.get(prevProps, 'stepData.fields.studyType', '');
        const currentStudyType = lodash.get(this.props, 'stepData.fields.studyType', '');

        const prevStudyStage = lodash.get(prevProps, 'stepData.fields.studyStage', '');
        const currentStudyStage = lodash.get(this.props, 'stepData.fields.studyStage', '');

        if (!lodash.isEqual(currentStudyType, prevStudyType)) {
            this.setState({ studyType: currentStudyType });
        }

        if (!lodash.isEqual(currentStudyStage, prevStudyStage)) {
            this.setState({ studyStage: currentStudyStage });
        }

    }

    missingFields() {
        return {
            studyName: this.state.studyName.length === 0,
            studyType: this.state.studyType.length === 0,
        };
    }

    onNameChange(e) {
        this.setState({ studyName: e.target.value }, () => {
            this.props.setField('studyName', this.state.studyName);
        });
    }

    onTypeChange(e) {
        const studyTypeIndex = e.target.value;
        const selectedStudyType = this.state.studyTypesOptions.find(option => option.id === studyTypeIndex);

        this.setState({ studyType: selectedStudyType }, () => {
            this.props.setField('studyType', this.state.studyType);
        });
    }

    onStageChange(e) {
        const studyStageIndex = e.target.value;
        const selectedStudyStage = this.state.studyStageOptions.find(option => option.id === studyStageIndex);

        this.setState({ studyStage: selectedStudyStage }, () => {
            this.props.setField('studyStage', this.state.studyStage);
        });
    }

    completeStep() {
        this.props.setField('studyName', this.state.studyName);
        this.props.setField('studyType', this.state.studyType);
        this.props.setField('studyStage', this.state.studyStage);
        this.props.progressToNextStep(this.state);
    }

    isDisabled() {
        const errors = this.missingFields();
        return Object.keys(errors).some(x => errors[x]);
    }

    getStudyFieldValue(fieldName) {
        return lodash.get(this.props, `stepData.fields.${fieldName}`, '');
    }
    

    render() {
        const { stepData: { isDraft = false }, onExit } = this.props;
        return (
            <Fragment>
                <form className={styles.studyTypeForm}>
                    <StudyStepTitle>
                        Study Name and Study Type
                    </StudyStepTitle>
                    <StudyName
                        className={styles.studyName}
                        studyName={this.state.studyName}
                        onNameChange={this.onNameChange}
                    />
                    <StudyStepInfoContainer>
                        <h4>
                            This name will appear and be searchable on the Complion home screen.
                        </h4>
                        <p>
                            If you have a name for this study that is required by your sponsor,
                            that can be provided separately in Study Details based on your study
                            type configuration.
                        </p>
                    </StudyStepInfoContainer>

                    <StudyTypeSelect
                        studyTypesOptions={this.state.studyTypesOptions}
                        selectedStudyType={this.state.studyType}
                        onChange={this.onTypeChange}
                    />

                    <StudyStepInfoContainer>
                        <Fragment>
                            <h4>
                                <i className={styles.lockIcon}>lock</i>
                                The Study Type cannot change after you have activated the Study.
                            </h4>
                            <p>
                                Study Types determine many of the details, documents,
                                and data that are appropriate for a given study.
                                Study Types are built and maintained for your team by Complion.
                            </p>
                        </Fragment>
                    </StudyStepInfoContainer>

                    <StudyStageSelect
                        studyStageOptions={this.state.studyStageOptions}
                        selectedStudyStage={this.state.studyStage}
                        onChange={this.onStageChange}
                    />
                </form>
                <PrimaryStepAction
                    saveButtonText='Save and Continue'
                    exitButtonText={`Exit ${isDraft ? 'Draft' : 'Study'}`}
                    onClickSave={this.completeStep}
                    onClickExit={onExit}
                    saveButtonDisabled={this.isDisabled()}
                />
            </Fragment>

        );
    }
}

export const StudyName = ({ id, className, label, studyName, onNameChange }) => (
    <StudyFormField
        className={className}
        isRequired
        id='studyName'
        label={'What is your team\'s name for this study?'}
    >
        <input
            autoFocus
            required
            type='text'
            onChange={onNameChange}
            className={styles.textBoxInput}
            id="studyName"
            name="studyName"
            value={studyName}
            placeholder="Name of Study..."
        />
    </StudyFormField>
);

export const StudyTypeSelect = ({ studyTypesOptions = [], selectedStudyType = null, onChange }) => {
    const defaultOption = 'Select Study Type';
    return (
        <StudyFormField
            isRequired
            id='studyType'
            label='What type of study is this?'
        >
            <select
                id='studyType'
                name='studyType'
                onChange={onChange}
                value={selectedStudyType ? selectedStudyType.id : defaultOption}
            >
                <option
                    value={defaultOption}
                    disabled
                    hidden
                >
                    Select a Study Type
                </option>
                {
                    studyTypesOptions.map((studyType) =>
                        <option
                            key={studyType.id}
                            value={studyType.id}>{studyType.name}</option>
                    )
                }
            </select>
        </StudyFormField>
    );
};

export const StudyStageSelect = ({ studyStageOptions = [], selectedStudyStage = null, onChange }) => {
    const defaultOption = 'Select a Lifecycle Stage';
    return (
        <StudyFormField
            id='studyStage'
            label='Lifecycle Stage'
        >
            <select
                value={selectedStudyStage ? selectedStudyStage.id : defaultOption}
                id='studyStage'
                name='studyStage'
                onChange={onChange}
            >
                <option value={defaultOption}>Select a Lifecycle Stage</option>
                {
                    studyStageOptions
                        .map(option =>
                            <option
                                key={option.id}
                                value={option.id}
                            >
                                {option.name}
                            </option>
                        )
                }
            </select>
        </StudyFormField>
    );
};

export default StudyType;
